import { App } from "vue";
import { createI18n } from "vue-i18n";

import store from "@/store";
import { queryI18nSysTags } from "@/api/system-words";

const locales = import.meta.glob("./*.json");

const i18n = createI18n({
  legacy: false,
  locale: store ? store.state.language.CURRENT_LANGUAGE : 'en-US',
  fallbackLocale: "en-US",
  messages: {},
});

export const { t } = i18n.global;

async function queryI18nSysListBatch(keys: string[]) {
  const BATCH_SIZE = 1000;
  const batches = [];
 
  for (let i = 0; i < keys.length; i += BATCH_SIZE) {
    batches.push(keys.slice(i, i + BATCH_SIZE));
  }

  // const responses = await Promise.allSettled(batches.map(batch => queryI18nSysList(batch)));
  // return responses.reduce((acc: any, response: any) => {
  //   if (response.status === "fulfilled") {
  //     Object.assign(acc, response.value.data?.data);
  //   }
  //   return acc;
  // }, {});

  const responses = await queryI18nSysTags({tags: 'portal-HARBOUR'});
  return responses.data.data
}

export async function loadLocaleMessages(locale: string) {
  let messages = null;

  try {
    messages = await locales[`./${locale}.json`]();
  } catch {
    messages = await locales[`./en-US.json`]();
  }
  store.commit("language/setCurrentLanguage", locale);

  let i18nList = Object.assign({}, messages.default);
  try {
    const i18nData = await queryI18nSysListBatch(Object.keys(i18nList));
    // The test environment and production environment need to configure entries url: https://locale.fat.driverglobe.com/dict-management
    if (process.env.NODE_ENV === "production") {
      i18nList = i18nData;
    } else {
      Object.assign(i18nList, i18nData);
    }
  } catch (err) {
    console.error("Failed to load remote internationalization entries", err);
  }

  i18n.global.locale.value = locale;
  i18n.global.setLocaleMessage(locale, i18nList);
}

/** 国际化不支持用户当前浏览器语言时默认使用 en-US */
async function detectUserPreferredLanguage(): Promise<string> {
  const language = (navigator.language || navigator.languages[0]) as string;
  const languageList = await store.dispatch("language/getLanguageList");

  if (Object.keys(languageList).includes(language)) {
    return language;
  } else {
    return "en-US";
  }
}

export async function initI18n(app: App) {
  app.use(i18n);
  const storeLanguage = store.state.language.CURRENT_LANGUAGE;
  const languageToLoad = storeLanguage || (await detectUserPreferredLanguage());
  await loadLocaleMessages(languageToLoad);
}

export default i18n;
